import React from 'react';
import { Button, Tooltip, Steps } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { UploadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const HistoricSteps = ({ documentModal, downloadFile }) => {
  const { t } = useTranslation();
  const { Step } = Steps;
  return (
    <Steps orientation="vertical" current={documentModal.length + 1}>
      {documentModal &&
        (documentModal.reverse() || []).map((item) => (
          <Step
            key={item._id}
            title={`Enregistré le ${moment(item.date).format(
              'DD-MM-YYYY'
            )} à ${moment(item.date).format('HH:mm')}`}
            description={
              <>
                <p>
                  <span>{`${t('contractDocuments.user')} : `}</span>
                  {item.user?.role?.includes('SUPER-ADMIN') ? (
                    'Assurmax'
                  ) : (
                    <span>
                      {!item.user
                        ? ''
                        : `${item.user?.first_name} ${item.user?.last_name}`}
                    </span>
                  )}
                </p>
                <p>
                  <span>
                    {`${t('contractDocuments.action')} : ${t(
                      `contractDocuments.history.${item.action}`
                    )}`}
                  </span>
                </p>
                {item.action === 'REFUSE' && (
                  <p>
                    <span>{`Motif : ${item.comment}`}</span>
                  </p>
                )}
                <p>
                  {item.files.map((element) => (
                    <span>
                      <Tooltip
                        placement="topLeft"
                        title={`${element && element?.metadata?.originalName}`}
                      >
                        <Button
                          style={{ marginLeft: -16 }}
                          type="link"
                          onClick={() => downloadFile(element)}
                        >
                          <UploadOutlined />
                          {element && element?.metadata?.originalName}
                        </Button>
                      </Tooltip>
                    </span>
                  ))}
                </p>
              </>
            }
          />
        ))}
    </Steps>
  );
};

HistoricSteps.propTypes = {
  documentModal: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  downloadFile: PropTypes.func.isRequired
};

export default HistoricSteps;
